module.exports = __webpack_public_path__ + "media/images/icons/outlined/chrome-23458502a532a321f6ee90a19d48d105.svg";